import React from "react";

interface SelectOption {
  label: string;
  value: string;
}

interface LabeledSelectProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: SelectOption[];
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  error?: string;
  hideIcon?: boolean;
  viewMode?: boolean;
}

const SelectdDropDown: React.FC<LabeledSelectProps> = ({
  id,
  label,
  value,
  onChange,
  options,
  placeholder,
  required = false,
  disabled = false,
  className = "",
  error,
  hideIcon,
  viewMode,
}) => {
  const selectedLabel =
    options.find((opt) => opt.value === value)?.label || "-";
  return (
    <div className="flex flex-col">
      <label
        htmlFor={id}
        className="block text-sm font-medium text-gray-700 mb-1"
      >
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      {viewMode ? (
        <p className="px-1 py-2 text-gray-900">{selectedLabel}</p>
      ) : (
        <select
          id={id}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500
          ${
            error
              ? "border-red-500 focus:ring-red-500"
              : "border-gray-300 focus:ring-indigo-500 focus:border-indigo-500"
          }
          disabled:bg-gray-100
          ${className}`}
        >
          {placeholder && (
            <option value="" disabled hidden>
              {placeholder}
            </option>
          )}

          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      )}
      {error && <span className="text-sm text-red-500 mt-1">{error}</span>}
    </div>
  );
};

export default SelectdDropDown;
